module.exports = __webpack_public_path__ + "img/Background-Glass-Cutting-Boards-no-text-jpg.28a56288.webp";